const Nyelvek = Object.freeze({
  Magyar: 'hu',
  Angol: 'en',
});

export default Nyelvek;
